import { Component, inject, ViewEncapsulation } from '@angular/core';
import { RouterOutlet }                 from '@angular/router';

import { MenuService }        from '../../shared/services/menu-service';
import { MenuItemsComponent } from '../../shared/components/menu/menu-items/menu-items.component';
import { MenuComponent }      from '../../shared/components/menu/menu.component';
import { HeaderComponent }    from '../../shared/components/header/header.component';
import { FooterComponent }    from '../../shared/components/footer/footer.component';

@Component({
  selector: 'pin-shell',
  templateUrl: './shell.component.html',
  encapsulation: ViewEncapsulation.None,
  imports: [MenuItemsComponent, MenuComponent, HeaderComponent, RouterOutlet, FooterComponent]
})
export class ShellComponent {
  public userName: string;
  public isSsoUser = false;
  public hasCustomerLevelAccess = false;
  customClass: string;
  private menuService = inject(MenuService);

  setUserName($event) {
    this.userName = $event;
  }

  setIsSsoUser($event) {
    this.isSsoUser = $event;
  }

  setHasCustomerLevelAccess($event) {
    this.hasCustomerLevelAccess = $event;
  }

  closeMenu = (): void => {
    this.menuService.changeVisibility(false);
  }
}
